$ = require 'jquery'
Auth = require 'db/auth'
BoardListSearchItemView = require 'views/board-list/board-list-search-item-view'
CardSearchResultView = require 'views/search/card-search-result-view'
Controller = require 'controller'
DragSort = require 'views/lib/drag-sort'
MemberSearchResultView = require 'views/search/member-search-result-view'
ModelLoader = require 'db/model-loader'
Promise = require 'bluebird'
SavedSearchView = require 'views/search/saved-search-view'
Search = require 'views/search/search'
SearchState = require 'view-models/search-state'
Util = require 'lib/util'
View = require 'view'
_ = require 'underscore'
getExperiment = require 'lib/experiments/simple-test'
log = require 'debug/log'
templates = require 'views/internal/templates'
track = require 'debug/track'
searchInstantResults = require 'views/templates/search_instant_results'
ClientConfig = require 'debug/client-config'

module.exports = class InstantSearchView extends View
  viewTitleKey: 'search results'

  className: 'search-results-view'

  displayType: 'mod-search-over'

  hideHeader: true

  maxWidth: '600'

  constructor: ->
    @results = null
    @serial = 0
    @suggestSerial = 0
    @idCardsLoaded = []
    @cardsLimit = if Controller.isOnSearchPage() then 12 else 8
    @cardsDesired = @cardsLimit
    @noMoreCardMatches = false
    @searchStates = ['no-results', 'no-input', 'searching', 'search-results', 'err']
    @searchState = 'no-results'
    super

  initialize: ->
    smartDebounce = (fn) =>
      @dynamicDebounce fn, (query) ->
        baseDelayMs = 600
        if query.length <= 1
          baseDelayMs * 3
        else if query.length <= 3
          baseDelayMs * 2
        else
          baseDelayMs

    debouncedUpdate = smartDebounce(@update).bind(@)
    debouncedSearchSuggest = smartDebounce(@renderSearchedSuggestions).bind(@)
    @listenTo SearchState,
      'change:query': (_, query) -> debouncedUpdate(query)
      'change:suggestions': @renderSuggestions
      'change:suggestionSearchTerm': (_, query) -> debouncedSearchSuggest(query)

    @listenTo Auth.me().savedSearchList, 'add remove reset change', @renderSavedSearches

  events:
    'click .js-see-all-saved-searches': 'seeAllSavedSearchesEvent'
    'click .js-saved-search-name': 'doSavedSearch'

    'sortstop .js-saved-searches-list': 'sortStop'

    'click .js-save-this-search': 'saveThisSearch'
    'input .js-saved-search-name-input': 'changeSearchName'
    'submit .js-save-this-search-form': 'confirmSave'
    'click .js-save-this-search-cancel': 'cancelSave'

    'click .js-show-search-tips': 'showTips'

    # track clicks
    'click .js-card-results .js-list a': 'trackCardClick'
    # What about boards? That's tracked in BoardListSearchItemView
    'click .js-member-results .js-list .js-select-member': 'trackMemClick'
    'click .js-org-results .js-list .list-card': 'trackOrgClick'

    # suggestions
    'click .js-select-suggestion': 'selectSuggestion'
    'mouseenter .js-select-suggestion': 'mouseenterSuggestion'
    'mouseleave .js-select-suggestion': 'mouseleaveSuggestion'

    # show more
    'click .js-show-more-cards': 'showMoreCards'
    'click .js-show-more-boards': 'showMoreBoards'
    'click .js-show-more-members': 'showMoreMembers'
    'click .js-show-more-orgs': 'showMoreOrgs'

    # hover over cards
    'mouseenter .search-result-card-hover-target': 'highlightCard'
    'mouseleave .search-result-card-hover-target': 'unHighlightCard'

    # help
    'click .js-open-help-query': 'trackOpenHelpQuery'
    'click .js-open-help a': 'trackOpenHelp'

    #track upsell clicks
    'click .js-business-class-link': 'trackBusinessClassClick'
    'click .js-gold-link': 'trackGoldClick'

  update: (query) ->
    @err = null
    @results = if _.isEmpty(query) then {} else null
    ++@serial
    reqSerial = @serial
    @renderResults()
    if _.isEmpty(query)
      return

    params = {
      query
      partial: true
      modelTypes: 'cards,boards,organizations,members'
      board_fields: 'name,url,prefs'
      # Load an extra card, so we can see if we should show the "Show more" option
      cards_limit: @cardsLimit + 1
      card_members: true
      card_board: true
      card_list: true
      card_stickers: true
      card_attachments: 'cover'
      boards_limit: 8
      members_limit: 8
      organizations_limit: 6
    }

    $searchHelpSite = @$('.js-open-help-query')
    $openHelpSite = @$('.js-open-help')
    # HelpScout doesn't want to handle quotes apparently
    helpQuery = query.replace(/"/g, '')
    hasSearch = /\S/.test(helpQuery)
    $openHelpSite.toggleClass('hide', hasSearch)
    $searchHelpSite
      .toggleClass('hide', !hasSearch)
      .attr('href', "http://help.trello.com/search?query=#{ encodeURIComponent(helpQuery) }&source=trello-search")
      .find('.js-query').text(helpQuery)

    ModelLoader.loadSearchData(params).nodeify (@err, results) =>
      if reqSerial != @serial
        terms = _.pluck(results?.options?.terms, 'text')
        log('search', "discarding search for #{terms}, serial #{reqSerial}")
        return
      @results = results
      @renderResults()
    return

  getMoreCards: (query, { partial }) ->
    Promise.try =>
      # We want to *display* the cards in pages of @cardsLimit … but we also
      # want to know if there are more cards to load.  To determine this, we
      # need to load at least one more card than we want to display; if there
      # isn't at least one more card, that means there aren't any more.
      #
      # Unfortunately, we can't _just_ set the cards_limit to one more, because
      # that also controls the page size; so, we load pages of size
      # @cardsLimit + 1.  This means that on the first load we have one
      # extra card loaded, on the second load we have two extra, etc … and
      # eventually we'll get to a point where we can display an extra page of
      # cards without needing to do an additional load.
      if @idCardsLoaded.length <= @cardsDesired  && !@noMoreCardMatches
        page = Math.floor(@cardsDesired / (@cardsLimit + 1))

        params = {
          query
          partial: partial ? false
          modelTypes: 'cards'
          board_fields: 'name,url,prefs'
          # Load an extra card, so we can see if we should show the "Show more" option
          cards_limit: @cardsLimit + 1
          cards_page: page
          card_members: true
          card_board: true
          card_list: true
          card_stickers: true
          card_attachments: 'cover'
        }

        ModelLoader.loadSearchData(params)
        .then (results) =>
          @idCardsLoaded = _.uniq(@idCardsLoaded.concat(_.pluck(results?.cards ? [], 'id')))
        .catch (err) =>
          @err = err
    .then =>
      @noMoreCardMatches = @idCardsLoaded.length <= @cardsDesired
      @renderCardResults()
      @$('.js-loading-cards').addClass('hide')
    .done()

    return

  render: ->
    data =
      savedSearchesEnabled: Auth.me().isFeatureEnabled('savedSearches')
      upsellEnabled: !ClientConfig.get('dontUpsell')
      searchEmptyStateEnabled: getExperiment('boardSearchEmptyStates').get('enabled')

    @$el.html(searchInstantResults(data))

    @update SearchState.getQuery()
    @renderSuggestions()
    @renderSearchedSuggestions SearchState.getSuggestionSearchTerm()

    @

  selectSuggestion: (e) ->
    Util.stop(e)
    $target = $(e.target).closest('.js-select-suggestion')
    suggestion = $target.attr('data-suggestionphrase')
    suggestionObj = Search.getKeywordMap()[suggestion]

    query = SearchState.getQuery()
    idx = Search.inputIndex

    strippedQuery = Util.removeWordAtIndex(query, idx)
    val = Util.stripExtraSpaces("#{strippedQuery} #{suggestion}")

    if !suggestionObj?.moreInputNeeded
      val += " "

    SearchState.clearSuggestions()
    SearchState.setQuery(val)

    SearchState.clearSuggestionSearchTerm()
    SearchState.clearSuggestionSearchModelTypes()

    track('Search', "Select Suggestion")
    return

  mouseleaveSuggestion: (e) ->
    @$('.js-select-suggestion').removeClass('selected')

  mouseenterSuggestion: (e) ->
    $(e.target).closest('.js-select-suggestion').addClass('selected')

  renderSuggestions: ->
    suggestions = SearchState.getSuggestions()
    hasSuggestions = suggestions.length > 0
    $suggestions = @$('.js-search-suggestions')
    $suggestionsList = $suggestions.find('.js-search-suggestions-list').empty()

    if hasSuggestions
      html = ""
      for key in suggestions
        obj = Search.getSuggestionObjectContainingVariantOrKey(key)
        suggestion = obj.obj
        suggestion.phrase = obj.key
        html += templates.fill('search_suggetion', suggestion)

      $suggestionsList.append(html)
      @$('.js-select-suggestion').first().addClass('selected')
      $suggestions.removeClass('hide')

    else
      $suggestions.addClass('hide')

    @

  renderSearchedSuggestions: (query) ->
    $suggestions = @$('.js-search-suggestions').addClass('hide')
    $suggestionsList = $suggestions.find('.js-search-suggestions-list').empty()
    ++@suggestSerial
    reqSerial = @suggestSerial

    if query == ""
      return

    params = {
      query
      modelTypes: SearchState.getSuggestionSearchModelTypes()
      partial: true
      board_fields: 'name,url,prefs'
      boards_limit: 6
      members_limit: 6
    }

    ModelLoader.loadSearchData(params).nodeify (err, results) =>

      if reqSerial != @suggestSerial
        return

      hasBoardResults = results?.boards?.length > 0
      hasMemberResults = results?.members?.length > 0
      hasResults = hasBoardResults || hasMemberResults
      html = ""

      if hasResults && !err

        if hasBoardResults

          for result in results.boards
            data = result
            data.phrase = "board:\"#{result.name}\""
            html += templates.fill('search_suggetion_board', data)

        else if hasMemberResults

          for result in results.members
            data = result
            data.phrase = "@#{result.username}"
            partials = { member: templates.member }
            html += templates.fill(
              'search_suggetion_member'
              data
              ""
              partials
            )

        $suggestionsList.append(html)
        @$('.js-select-suggestion').first().addClass('selected')
        $suggestions.removeClass('hide')

    return

  renderResults: ->
    # If we're re-rendering the results, we can reset the list of cards that
    # have been loaded
    @idCardsLoaded = _.pluck(@results?.cards ? [], 'id')
    @noMoreCardMatches = @idCardsLoaded.length <= @cardsLimit

    idBoards = _.pluck(@results?.boards ? [], 'id')
    idMembers = _.pluck(@results?.members ? [], 'id')
    idOrgs = _.pluck(@results?.organizations ? [], 'id')

    @searchState = if @err?
      'err'
    else if SearchState.getQuery() == ""
      'no-input'
    else if !@results?
      'searching'
    else if _.all([@idCardsLoaded, idBoards, idMembers, idOrgs], _.isEmpty)
      'no-results'
    else
      @renderCardResults()
      @renderBoardResults(idBoards)
      @renderMemberResults(idMembers)
      @renderOrganizationResults(idOrgs)

      'search-results'

    @renderSavedSearches()

    # Even though it happens to be the case right now that
    # we could build this via string concatenation, that's a
    # complete coincidence and there's no reason the private
    # values we use in this class should be known in the
    # templates.
    stateToClassMap =
      'err': 'js-err'
      'no-input': 'js-no-input'
      'searching': 'js-searching'
      'no-results': 'js-no-results'
      'search-results': 'js-search-results'

    for state in @searchStates
      className = stateToClassMap[state]
      $(@el.getElementsByClassName className)
      .toggleClass('hide', state != @searchState)

    @

  renderSavedSearches: ->
    noInput = @searchState == 'no-input'
    $saveSearchMenu = @$('.js-save-this-search-menu')
    menuOpen = !$saveSearchMenu.hasClass('hide')
    @$('.js-saved-search-links').toggleClass('hide',  noInput || menuOpen)
    $savedSearches = @$('.js-saved-searches').toggleClass('hide',  !noInput)
    if noInput
      $saveSearchMenu.addClass('hide')
      @renderSavedSearchItems($savedSearches)
    else
      # If currently viewing a saved search, display its name rather
      # than offering to save it again.
      query = SearchState.getQuery()
      currentSearch = _.find Auth.me().savedSearchList.models,
        (x) -> x.toJSON().query == query
      if currentSearch?
        @$('.js-current-search-name').text(currentSearch.get('name'))
      @$('.js-save-this-search').toggleClass('hide', currentSearch?)
      @$('.js-current-search').toggleClass('hide', !currentSearch?)

    @

  renderSavedSearchItems: ($savedSearches) ->
    $savedSearchList = $savedSearches.find('.js-saved-searches-list')

    $savedSearchList.sortable
      axis: 'y'
      delay: '75'
      distance: '7'
      containment: '.js-saved-searches-list'
      tolerance: 'pointer'
      items: '.saved-search'
      start: (event, ui) ->
        DragSort.sorting = true
        _height = $(ui.helper).outerHeight()
        $(ui.placeholder).height(_height)
      stop: =>
        # Must defer this for the glory of Firefox!
        @defer ->
          DragSort.sorting = false

    me = Auth.me()
    savedSearches = me.savedSearchList.models
    @$('.js-no-saved-searches').toggleClass('hide', savedSearches.length > 0)
    subviews = (@subview(SavedSearchView, model, { parent: @ }) for model in savedSearches)
    $savedSearchList.empty()
    @appendSubviews(subviews, $savedSearchList)

    @

  renderCardResults: ->
    $cardResults = @$('.js-card-results')
    $cardResultsList = $cardResults.find('.js-list')

    cardSubviews = @idCardsLoaded.slice(0, @cardsDesired).map (idCard) =>
      card = @modelCache.get('Card', idCard)
      @subview(CardSearchResultView, card)

    @ensureSubviews(cardSubviews, $cardResultsList)

    $cardResults.toggleClass('hide', @idCardsLoaded.length == 0)
    @$('.js-show-more-cards').toggleClass('hide', @noMoreCardMatches)

    @

  renderBoardResults: (idBoards) ->
    $boardResults = @$('.js-board-results').addClass('hide')
    if idBoards.length > 0
      $boardResultsList = $boardResults.find('.js-list').empty()

      boardSubviews = for idBoard in idBoards
        @subview(BoardListSearchItemView, @modelCache.get('Board', idBoard))

      @appendSubviews(boardSubviews, $boardResultsList)
      $boardResults.removeClass('hide')

    moreBoardsToShow = false
    @$('.js-show-more-boards').toggleClass('hide', !moreBoardsToShow)

    @

  renderMemberResults: (idMembers) ->
    $memResults = @$('.js-member-results').addClass('hide')
    if idMembers.length > 0
      $memResultsList = $memResults.find('.js-list').empty()

      memberSubviews = for idMem in idMembers
        @subview(MemberSearchResultView, @modelCache.get('Member', idMem))

      @appendSubviews(memberSubviews, $memResultsList)
      $memResults.removeClass('hide')

    moreMembersToShow = false
    @$('.js-show-more-members').toggleClass('hide', !moreMembersToShow)

    @

  renderOrganizationResults: (idOrgs) ->
    $orgResults = @$('.js-org-results').addClass('hide')
    if idOrgs.length > 0

      orgHtml = for idOrg in idOrgs
        templates.fill(
          'organization_search_list_item',
          @modelCache.get('Organization', idOrg).toJSON()
        )

      $orgResults
      .removeClass('hide')
      .find('.js-list').empty().append(orgHtml)

    moreOrgsToShow = false
    @$('.js-show-more-orgs').toggleClass('hide', !moreOrgsToShow)

    @

  seeAllSavedSearchesEvent: ->
    @clearSearch()
    track("Search", "Saved Search", "See All Saved Searched (Go Back)")

  clearSearch: ->
    SearchState.setQuery('')

  doSavedSearch: (e) ->
    query = @$(e.target).closest('.saved-search').find('.js-saved-search-query').text()
    SearchState.setQuery(query)
    track("Search", "Saved Search", "Open Saved Search")

  sortStop: (e, ui) ->
    Util.stopPropagation(e)
    ui.item.trigger('movesavedsearch', [ui])
    track("Search", "Saved Search", "Reorder Saved Searches")
    return

  saveThisSearch: ->
    @$('.js-saved-search-links').addClass('hide')
    @$('.js-save-this-search-menu').removeClass('hide')
    @$('.js-saved-search-name-input').val('').focus()
    @$('.js-save-this-search-submit').addClass('disabled')

  changeSearchName: ->
    submit = @$('.js-save-this-search-submit')
    input = @$('.js-saved-search-name-input')
    submit.toggleClass('disabled', input.val().trim().length == 0)
    track("Search", "See All Saved Searches")

  confirmSave: (e) ->
    Util.preventDefault(e)
    if !@$('.js-save-this-search-submit').hasClass('disabled')
      name = @$('.js-saved-search-name-input').val().trim()
      query = SearchState.getQuery()
      Auth.me().savedSearchList.saveSearch name, query
      @cancelSave()
      track("Search", "Saved Search", "Save")

  cancelSave: ->
    @$('.js-saved-search-links').removeClass('hide')
    @$('.js-save-this-search-menu').addClass('hide')
    track("Search", "Saved Search", "Cancel Save")

  closeAllDeleteMenus: ->
    for sibling in @subviewsOfType(SavedSearchView)
      sibling.cancelDeletion()

  trackCardClick:   -> track("Search", "Select Item", "Card")
  trackMemClick:    -> track("Search", "Select Item", "Member")
  trackOrgClick:    -> track("Search", "Select Item", "Team")

  trackOpenHelpQuery:   -> track("Search", "Open Help with Query")
  trackOpenHelp:        -> track("Search", "Open Help or Guide")

  trackBusinessClassClick:  -> track("Search", "Click Business Class Link", "Save Search Menu")
  trackGoldClick:           -> track("Search", "Click Gold Link", "Save Search Menu")

  showTips: (e) ->
    Util.stop(e)
    @$('.js-search-tips-helper').addClass('hide')
    @$('.js-search-tips-list').removeClass('hide')
    track("Search", "Show Tips")
    return

  showMoreCards: (e) ->
    @$('.js-loading-cards').removeClass('hide')
    @$('.js-show-more-cards').addClass('hide')
    @cardsDesired += @cardsLimit
    @getMoreCards(SearchState.getQuery(), { partial: true })
    track("Search", "Show More Cards")
    return

  showMoreBoards: (e) ->
    # TODO: load moar
    # track("Search", "Show More Boards")
    return

  showMoreMembers: (e) ->
    # TODO: load moar
    # track("Search", "Show More Members")
    return

  showMoreOrgs: (e) ->
    # TODO: load moar
    # track("Search", "Show More Teams")
    return


  highlightCard: (e) ->
    $card = $(e.target).closest('.search-result-card').addClass('search-result-card-highlight-card')
    $card.closest('.js-list').addClass('search-result-card-highlight-section')
    return

  unHighlightCard: (e) ->
    $card = $(e.target).closest('.search-result-card').removeClass('search-result-card-highlight-card')
    $card.closest('.js-list').removeClass('search-result-card-highlight-section')
    return



// WEBPACK FOOTER //
// ./app/scripts/views/search/instant-search-view.coffee